/** A4 page width in mm. */
export const A4_WIDTH_MM = 210;

/** A4 page height in mm. */
export const A4_HEIGHT_MM = 297;

/** Standard A4 dimensions in 96 DPI CSS pixels (297mm * 96 / 25.4 = 1122.52px). */
export const DEFAULT_A4_HEIGHT_PX = 1123;
export const DEFAULT_A4_WIDTH_PX = 794;

let cachedPageHeightPx: number | null = null;
let cachedPageWidthPx: number | null = null;

function measureMmToPx(mm: number, defaultPx: number, minValidPx: number): number {
  if (typeof document === 'undefined' || !document.body) {
    return defaultPx;
  }
  try {
    const measureEl = document.createElement('div');
    measureEl.style.width = `${mm}mm`;
    measureEl.style.position = 'absolute';
    measureEl.style.visibility = 'hidden';
    measureEl.style.pointerEvents = 'none';
    measureEl.style.top = '-9999px';
    document.body.appendChild(measureEl);
    const px = measureEl.offsetWidth || measureEl.getBoundingClientRect().width;
    document.body.removeChild(measureEl);
    return px >= minValidPx ? px : defaultPx;
  } catch {
    return defaultPx;
  }
}

/**
 * Per-page content padding cloned by box-decoration-break:clone on <main>.
 * Must match the pt/pb values in Compact MainContent.
 */
export const PAGE_CONTENT_PADDING_TOP = 16;
export const PAGE_CONTENT_PADDING_BOTTOM = 16;

/** Returns the height of an A4 page (297mm) in pixels, cached after first call. */
export function getPageHeightInPx(): number {
  if (cachedPageHeightPx !== null && cachedPageHeightPx >= 800) return cachedPageHeightPx;
  cachedPageHeightPx = measureMmToPx(A4_HEIGHT_MM, DEFAULT_A4_HEIGHT_PX, 800);
  return cachedPageHeightPx;
}

/** Returns the width of an A4 page (210mm) in pixels, cached after first call. */
export function getPageWidthInPx(): number {
  if (cachedPageWidthPx !== null && cachedPageWidthPx >= 500) return cachedPageWidthPx;
  cachedPageWidthPx = measureMmToPx(A4_WIDTH_MM, DEFAULT_A4_WIDTH_PX, 500);
  return cachedPageWidthPx;
}
